var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuelStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#E1EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24.9583H8.5C8.15833 24.9583 7.875 24.6749 7.875 24.3333C7.875 23.9916 8.15833 23.7083 8.5 23.7083H23.5C23.8417 23.7083 24.125 23.9916 24.125 24.3333C24.125 24.6749 23.8417 24.9583 23.5 24.9583Z",
    fill: "#6374FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 22.4584H9.33333C8.53333 22.4584 7.875 21.8001 7.875 21.0001V13.8167C7.875 13.0167 8.53333 12.3584 9.33333 12.3584H10.6666C11.4666 12.3584 12.125 13.0167 12.125 13.8167V21.0001C12.125 21.8001 11.4666 22.4584 10.6666 22.4584ZM9.33333 13.6001C9.21667 13.6001 9.125 13.6917 9.125 13.8084V21.0001C9.125 21.1167 9.21667 21.2084 9.33333 21.2084H10.6666C10.7833 21.2084 10.875 21.1167 10.875 21.0001V13.8167C10.875 13.7001 10.7833 13.6084 10.6666 13.6084H9.33333V13.6001Z",
    fill: "#6374FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 22.4583H15.3333C14.5333 22.4583 13.875 21.7999 13.875 20.9999V11.1583C13.875 10.3583 14.5333 9.69995 15.3333 9.69995H16.6666C17.4666 9.69995 18.125 10.3583 18.125 11.1583V20.9999C18.125 21.7999 17.4666 22.4583 16.6666 22.4583ZM15.3333 10.95C15.2167 10.95 15.125 11.0416 15.125 11.1583V20.9999C15.125 21.1166 15.2167 21.2083 15.3333 21.2083H16.6666C16.7833 21.2083 16.875 21.1166 16.875 20.9999V11.1583C16.875 11.0416 16.7833 10.95 16.6666 10.95H15.3333Z",
    fill: "#6374FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 22.4584H21.3333C20.5333 22.4584 19.875 21.8001 19.875 21.0001V8.50008C19.875 7.70008 20.5333 7.04175 21.3333 7.04175H22.6666C23.4666 7.04175 24.125 7.70008 24.125 8.50008V21.0001C24.125 21.8001 23.4666 22.4584 22.6666 22.4584ZM21.3333 8.29175C21.2167 8.29175 21.125 8.38341 21.125 8.50008V21.0001C21.125 21.1167 21.2167 21.2084 21.3333 21.2084H22.6666C22.7833 21.2084 22.875 21.1167 22.875 21.0001V8.50008C22.875 8.38341 22.7833 8.29175 22.6666 8.29175H21.3333Z",
    fill: "#6374FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuelStats);
export default __webpack_public_path__ + "static/media/Duel Stats.a99ca171d3d8837a356918efc30fae0f.svg";
export { ForwardRef as ReactComponent };